const about = require('./about');
const confirmation = require('./confirmation');
const lifewall = require('./lifewall');
const pay = require('./pay');
const pricing = require('./pricing');
const products = require('./products');
const replace = require('./replace');
const surveys = require('./surveys');

if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'about'
) {
	about.init();
}
if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'confirmation'
) {
	confirmation.init();
}
if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'lifewall'
) {
	lifewall.init();
}
if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'pay'
) {
	pay.init();
}
if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'pricing'
) {
	pricing.init();
}
if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'products'
) {
	products.init();
}
if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'replace'
) {
	replace.init();
}
if (
	window.iq &&
	window.iq.hasOwnProperty('memb_screen') &&
	window.iq.memb_screen === 'surveys'
) {
	surveys.init();
}
